import { render, staticRenderFns } from "./deliveryOrderDetails.vue?vue&type=template&id=211d185e&scoped=true&"
import script from "./deliveryOrderDetails.vue?vue&type=script&lang=js&"
export * from "./deliveryOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./deliveryOrderDetails.vue?vue&type=style&index=0&id=211d185e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211d185e",
  null
  
)

export default component.exports